module.exports = __webpack_public_path__ + "static/img/stamp.f24defd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/event/stamp/stamp.jpg
// module id = DuLA
// module chunks = 1